// extracted by mini-css-extract-plugin
export default {"passkeyHeader":"PasskeyOfferModal__passkeyHeader__sAudP","passkeyBody":"PasskeyOfferModal__passkeyBody__R5iv5"};